import ProfileModal from './ProfileModal'

export default ProfileModal
